import React, { useState, useEffect } from "react";
import { getProfile, UpdateDonorDetailsAPI } from "../../api/apiHandler";
import NavBar from "../../components/NavBar/NavBar";
import Heading from "../../components/Heading/Heading";
import { useForm } from "react-hook-form";
import { SWIT_SUCCESS } from "../Common/CommonFunctions";
import { useNavigate } from "react-router-dom";

function UpdateDonorProfile({ isLoader }) {
  const navigate = useNavigate();
  const [donorData, setDonorData] = useState({});
  const [loading, setLoading] = useState(true);
  const { register, handleSubmit, setValue, formState: { errors } } = useForm();

  useEffect(() => {
    const donor_id = localStorage.getItem("DAid");
    getProfile({ donor_id })
      .then((res) => {
        if (res.data.code == 1) {
          const data = res.data.data;
          setDonorData(data);
          setValue("full_name", data?.full_name || "");
          setValue("email", data?.email || "");
          setValue("phone_number", data?.phone_number || "");
          setValue("address_line1", data?.address_line1 || "");
          setValue("address_line2", data?.address_line2 || "");
          setValue("city", data?.city || "");
          setValue("state", data?.state || "");
          setValue("country", data?.country || "");
          setValue("zip_code", data?.zip_code || "");
        } else {
          console.warn("Profile fetch failed:", res.data);
        }
        setLoading(false);
      })
      .catch((err) => {
        console.error("Error fetching donor profile:", err);
        setLoading(false);
      });
  }, [setValue]);

  const onSubmit = async (data) => {
    const donor_id = localStorage.getItem("DAid");
    isLoader(true);

    const submitData = { donor_id, ...data };

    await UpdateDonorDetailsAPI(submitData)
      .then((res) => {
        isLoader(false);
        if (res.data.code == 1) {
          SWIT_SUCCESS(res.data.message);
          navigate('/dashboard')
        }
      })
      .catch((err) => {
        console.error("Error updating donor profile:", err);
        isLoader(false);
      });
  };

  return (
    <>
      <NavBar />
      <section className="content home">
        <Heading title="Update Donor Profile" />
        <div className="container-fluid">
          <div className="row clearfix">
            <div className="col-lg-12">
              <div className="card">
                <div className="body">
                  <form className="col-lg-12" onSubmit={handleSubmit(onSubmit)}>
                      <div className="form-group form-float">
                        <label className="form-label">Full Name</label>
                        <div className="form-line">
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Full Name"
                            {...register("full_name", { required: "Full Name is required" })}
                          />
                        </div>
                        {errors.full_name && (
                          <label className="errorc">{errors.full_name.message}</label>
                        )}
                      </div>
                      <div className="form-group form-float">
                        <label className="form-label">Email</label>
                          <input
                            type="email"
                            className="form-control"
                            placeholder="Email"
                            disabled
                            {...register("email")}
                          />
                      </div>
                      <div className="form-group form-float">
                        <label className="form-label">Phone Number</label>
                        <div className="form-line">
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Phone Number"
                            {...register("phone_number", { required: "Phone number is required" })}
                          />
                        </div>
                        {errors.phone_number && (
                          <label className="errorc">{errors.phone_number.message}</label>
                        )}
                      </div>
                      <div className="row">
                        <div className="col-lg-6">
                        <div className="form-group">
                          <label>Address Line 1</label>
                            <div className="form-line">
                                <input
                                  type="text"
                                  className="form-control"
                                  placeholder="Address Line 1"
                                  {...register("address_line1")}
                                />
                            </div>
                          </div>
                        </div>
                        <div className="col-lg-6">
                          <div className="form-group">
                            <label>Address Line 2</label>
                            <div className="form-line">
                              <input
                                type="text"
                                className="form-control"
                                placeholder="Address Line 2"
                                {...register("address_line2")}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-lg-6">
                          <div className="form-group">
                            <label>City</label>
                            <div className="form-line">
                              <input
                                type="text"
                                className="form-control"
                                placeholder="City"
                                {...register("city")}
                              />
                            </div>
                          </div>
                        </div>
                        <div className="col-lg-6">
                          <div className="form-group">
                            <label>State</label>
                            <div className="form-line">
                              <input
                                type="text"
                                className="form-control"
                                placeholder="State"
                                {...register("state")}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-lg-6">
                          <div className="form-group">
                            <label>Country</label>
                            <div className="form-line">
                              <input
                                type="text"
                                className="form-control"
                                placeholder="Country"
                                {...register("country")}
                              />
                            </div>
                          </div>
                        </div>
                        <div className="col-lg-6">
                          <div className="form-group">
                            <label>Zip Code</label>
                            <div className="form-line">
                              <input
                                type="text"
                                className="form-control"
                                placeholder="Zip Code"
                                {...register("zip_code")}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-12 mt-3">
                        <button
                          type="submit"
                          className="btn btn-raised btn-primary waves-effect"
                        >
                          Update Profile
                        </button>
                      </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default UpdateDonorProfile;
